export var AssignmentMode;
(function (AssignmentMode) {
    AssignmentMode["NO_CHANGES"] = "no_changes";
    AssignmentMode["ASSIGN_RECIPES"] = "assign_recipes";
    AssignmentMode["ADD_MEALS"] = "add_meals";
    AssignmentMode["BOTH"] = "both";
    AssignmentMode["NO_CONFIG"] = "no_config";
})(AssignmentMode || (AssignmentMode = {}));
